import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractApprovalPipe } from './contractApproval.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [ContractApprovalPipe],
    providers: [ContractApprovalPipe],
    exports: [ContractApprovalPipe],
})
export class ContractApprovalPipeModule {}
